var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.25V11.625C20 10.7299 19.6444 9.87145 19.0115 9.23851C18.3786 8.60558 17.5201 8.25 16.625 8.25H15.125C14.8266 8.25 14.5405 8.13147 14.3295 7.9205C14.1185 7.70952 14 7.42337 14 7.125V5.625C14 4.72989 13.6444 3.87145 13.0115 3.23851C12.3785 2.60558 11.5201 2.25 10.625 2.25H8.75M12.5 11.25V18.75M14.75 12.284C13.6203 11.9931 12.4449 11.9241 11.289 12.081C10.753 12.153 10.315 12.559 10.268 13.098C10.2561 13.2317 10.2501 13.3658 10.25 13.5C10.25 13.964 10.586 14.344 11.025 14.494L13.975 15.506C14.415 15.656 14.75 16.036 14.75 16.5C14.75 16.636 14.744 16.77 14.732 16.902C14.685 17.441 14.247 17.847 13.711 17.919C12.555 18.0743 11.3799 18.0054 10.25 17.716M11 2.25H6.125C5.504 2.25 5 2.754 5 3.375V20.625C5 21.246 5.504 21.75 6.125 21.75H18.875C19.496 21.75 20 21.246 20 20.625V11.25C20 8.86305 19.0518 6.57387 17.364 4.88604C15.6761 3.19821 13.3869 2.25 11 2.25Z",
    stroke: "#525355",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotations);
export default __webpack_public_path__ + "static/media/Quotations.c0783851143e6a5ca2815ffaf8a6d8e0.svg";
export { ForwardRef as ReactComponent };